import React from "react";
import { useThemeMode } from '../../../context/contextTheme';
import { useNetwork } from '../../../context/Dashboard/contextNetwork';
import './style.css';

const OpenPorts = () => {
  const { theme } = useThemeMode();
  const { ipServices } = useNetwork();

  const normalize = (item) => ({
    port: item?.port || item?.Port || "",
    service: item?.service || item?.Service || "Unknown",
    version: item?.version || item?.Version || "",
  });

  const ports = Array.isArray(ipServices)
    ? ipServices.map(normalize)
    : [];

  ports.sort((a, b) => {
    const ap = parseInt(String(a.port).split("/")[0], 10);
    const bp = parseInt(String(b.port).split("/")[0], 10);
    return (isNaN(ap) ? 0 : ap) - (isNaN(bp) ? 0 : bp);
  });

  return (
    <div className="p-2 pb-0 mb-3">
      <div
        className="card rounded-4 shadow-sm"
        style={{
          minWidth: 300, width: 360, height: 170,
          backgroundColor: theme.background,
          border: `1px solid ${theme.border}`,
        }}>
        
        <div className="card-body p-4">
          <h6 className="card-title fw-semibold mb-2"
              style={{ fontSize: "20px", color: theme.textColor }}>
            Open Ports
          </h6>

          <div className="scrollbar-all-primary overflow-auto" style={{ maxHeight: 80 }}>
            {ports.length > 0 ? (
              ports.map((item, idx) => (
                <div className="d-inline-block me-2 mb-2" key={`${item.port}-${idx}`}>
                  <span
                    className="badge text-light fw-semibold"
                    style={{
                      fontSize: 13,
                      backgroundColor: theme.secondary,
                      padding: "6px 10px",
                    }}>
                    {item.port}
                  </span>

                  {/* Show service and version (optional) */}
                  <div style={{ fontSize: 11, color: theme.textMuted }}>
                    {/* {item.service} */}
                    {/* {item.version ? ` • ${item.version}` : ""} */}
                  </div>
                </div>
              ))
            ) : (
              <div className="small" style={{ color: theme.textMuted }}>
                No open ports detected.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpenPorts;
